import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Input,
  Card,
  CardBody,
  CardTitle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  CustomInput,
  FormGroup,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';

import {
  faCommentDots,
  faEdit,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import TagsInput from 'react-tagsinput';
import {
  putAPI_Update_Response,
  postAPI_Create_A_Message,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../../propinfo/gallery/index';

function Message({
  setIsAddMsgToFalse,
  elem,
  dialogUpdate,
  dialogIndex,
  dialogNames,
  propertyId,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [messageInput, setMessageInput] = useState('');
  const [messageType, setMessageType] = useState('Normal');
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [postData, setPostData] = useState(elem);
  const [suggestInput, setSuggestInput] = useState('');
  const [suggestButtons, setSuggestButtons] = useState([]);
  const [apiHeroCardInput, setApiHeroCardInput] = useState('');
  const [suggestActions, setSuggestActions] = useState([]);
  const [targetInput, setTargetInput] = useState('');
  const [compInput, setCompInput] = useState('');
  const [compAInput, setCompAInput] = useState('');
  const [compBInput, setCompBInput] = useState('');
  const [questionOptionsInput, setQuestionOptionsInput] = useState({
    type: 'questionoptions',
    question: 'Please enter the question',
    slot: '',
    after: '',
    alwaysask: true,
    showButtons: false,
    options: [],
  });
  const [heroCardInput, setHeroCardInput] = useState({
    type: 'herocard',
    title: '',
    subtitle: '',
    imageURL: '',
    actions: [],
  });
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [inputFields, setInputFields] = useState([]);
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const handleCheckChange = (e) => {
    setQuestionOptionsInput({
      ...questionOptionsInput,
      [e.target.name]: e.target.checked,
    });
  };
  const handleQuestionOptionChange = (e) => {
    setQuestionOptionsInput({
      ...questionOptionsInput,
      [e.target.name]: e.target.value,
    });
  };
  const handleHeroCardInputChange = (e) => {
    setHeroCardInput({
      ...heroCardInput,
      [e.target.name]: e.target.value,
    });
  };
  const handleQuestionOptionsChange = (event) => {
    if (event.length > 0) {
      setQuestionOptionsInput({
        ...questionOptionsInput,
        showButtons: true,
        options: event,
      });
    } else {
      setQuestionOptionsInput({
        ...questionOptionsInput,
        showButtons: false,
        options: event,
      });
    }
  };
  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({
      type: '',
      title: '',
    });
    setInputFields(values);
    setIsEditing(true);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
    setIsEditing(true);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === 'type') {
      values[index].type = event.target.value;
    } else {
      values[index].title = event.target.value;
    }

    setInputFields(values);
    setIsEditing(true);
  };

  const selectedImage = (link) => {
    console.log(link);
    setHeroCardInput({
      ...heroCardInput,
      imageURL: link.src,
    });
  };

  const handleTextChange = (e) => {
    setMessageInput(e.target.value);
  };

  const handleSuggestionChange = (e) => {
    setSuggestInput(e.target.value);
  };

  const handleApiHeroCardChange = (e) => {
    setApiHeroCardInput(e.target.value);
  };
  const handleTargetChange = (e) => {
    setTargetInput(e.target.value);
  };

  const handleValueChange = (e) => {
    setMessageType(e.target.value);
  };

  const handleCompChange = (e) => {
    setCompInput(e.target.value);
  };
  const handleCompAChange = (e) => {
    setCompAInput(e.target.value);
  };
  const handleCompBChange = (e) => {
    setCompBInput(e.target.value);
  };

  useEffect(() => { }, [messageInput]);

  const handleSave = async () => {
    console.log('messageType', messageType);
    const data = { ...postData };
    if (messageType == 'Normal') {
      data.messages.push(messageInput);
    } else if (messageType == 'ApiCode') {
      data.messages.push({
        type: 'apimessage',
        apiCode: messageInput,
      });
    } else if (messageType == 'Suggest') {
      data.messages.push({
        type: 'suggest',
        text: suggestInput,
        buttons: suggestButtons,
      });
    } else if (messageType == 'ApiCodeHeroCard') {
      data.messages.push({
        type: 'apimessage-herocard-fixed',
        apiCode: apiHeroCardInput,
        actions: suggestActions,
      });
    } else if (messageType == 'GoTo') {
      let goData = {
        type: 'goto',
        target: targetInput,
      };
      if (compInput !== '') {
        goData.comp = compInput;
      }
      if (compAInput !== '') {
        goData.compA = compAInput;
      }
      if (compBInput !== '') {
        goData.compB = compBInput;
      }
      data.messages.push(goData);
    } else if (messageType == 'QuestionOptions') {
      data.messages.push(questionOptionsInput);
    } else if (messageType == 'HeroCard') {
      heroCardInput.actions = inputFields;
      data.messages.push(heroCardInput);
    }

    console.log('data', data);
    dialogUpdate(data, dialogIndex);
    if (setIsAddMsgToFalse) {
      setIsAddMsgToFalse();
    }
  };

  const handleCancel = () => {
    if (setIsAddMsgToFalse) {
      setIsAddMsgToFalse();
    }
  };
  const handleTagChange = (event) => {
    setSuggestButtons(event);
    console.log(event);
  };
  const handleActionChange = (event) => {
    setSuggestActions(event);
    console.log(event);
  };
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    propertyId={propertyId}
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const Editing = () => {
    return (
      <Fragment>
        <CardTitle>
          <Row style={{ textAlign: 'left' }}>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faCommentDots} />
                <span> </span>
                <IntlMessages id="property.message" />
              </div>
            </Colxx>
            <Colxx xxs="6">
              <div className="float-right">
                <Button
                  color="primary"
                  className="add-button"
                  size="xs"
                  onClick={handleSave}
                >
                  Save
                </Button>
                <b> </b>
                <Button
                  color="secondary"
                  className="add-button"
                  size="xs"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row className="mb-2">
          <Colxx xxs="2">
            <Label>Type</Label>
          </Colxx>
          <Colxx xxs="3">
            <Input type="select" name="type" onChange={handleValueChange}>
              <option value="Normal">Global</option>
              <option value="ApiCode">Pick from dashboard</option>
              <option value="Suggest">Quick Reply</option>
              <option value="ApiCodeHeroCard">
                Pick from dashboard with Actions
              </option>
              <option value="GoTo">Go To</option>
              <option value="QuestionOptions">Ask a Question</option>
              <option value="HeroCard">Hero Card</option>
            </Input>
          </Colxx>
        </Row>
        {(messageType === 'Normal' || messageType === 'ApiCode') && (
          <Colxx xxs="12">
            <Input
              type="textarea"
              defaultValue={messageInput}
              onChange={handleTextChange}
            />
          </Colxx>
        )}
        {messageType === 'Suggest' && (
          <Fragment>
            <Colxx xxs="12" className="mb-2">
              <Input
                type="text"
                value={suggestInput}
                onChange={handleSuggestionChange}
              />
            </Colxx>
            <Colxx xxs="12" className="mb-2">
              <TagsInput
                inputProps={{ placeholder: 'Add Button' }}
                value={suggestButtons}
                onChange={(event) => handleTagChange(event)}
              />
            </Colxx>
          </Fragment>
        )}
        {messageType === 'ApiCodeHeroCard' && (
          <Fragment>
            <Colxx xxs="12" className="mb-2">
              <Input
                type="text"
                value={apiHeroCardInput}
                onChange={handleApiHeroCardChange}
              />
            </Colxx>
            <Colxx xxs="12" className="mb-2">
              <TagsInput
                inputProps={{ placeholder: 'Add Action' }}
                value={suggestActions}
                onChange={(event) => handleActionChange(event)}
              />
            </Colxx>
          </Fragment>
        )}
        {messageType === 'GoTo' && (
          <Fragment>
            <Row className="mb-2">
              <Colxx xxs="4">
                <Label>Compare A</Label>
                <Input
                  type="text"
                  value={compAInput}
                  onChange={handleCompAChange}
                  name="compA"
                />
              </Colxx>
              <Colxx xxs="4">
                <Label>Equation</Label>
                <Input
                  type="select"
                  value={compInput}
                  onChange={handleCompChange}
                  name="comp"
                >
                  <option value={''}>Please Select</option>
                  <option value={'EQUAL'}>EQUAL</option>
                  <option value={'TRUE'}>TRUE</option>
                  <option value={'FALSE'}>FALSE</option>
                </Input>
              </Colxx>
              <Colxx xxs="4">
                <Label>Compare B</Label>
                <Input
                  type="text"
                  value={compBInput}
                  onChange={handleCompBChange}
                  name="compB"
                />
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12" className="mb-2">
                <Label>Go To: Select or Type</Label>
                <Input
                  type="select"
                  value={targetInput}
                  onChange={handleTargetChange}
                >
                  <option value={''}>Please Select</option>
                  {dialogNames.map((name) => {
                    return <option value={name}>{name}</option>;
                  })}
                </Input>
              </Colxx>
              <Colxx xxs="12" className="mb-2">
                -OR-
              </Colxx>
              <Colxx xxs="12" className="mb-2">
                <Input
                  type="text"
                  defaultValue={targetInput}
                  onChange={handleTargetChange}
                />
              </Colxx>
            </Row>
          </Fragment>
        )}
        {messageType === 'QuestionOptions' && (
          <Fragment>
            <Row>
              <Colxx xxs="12" className="mb-2">
                <Label>Question</Label>
                <Input
                  type="text"
                  defaultValue={
                    questionOptionsInput.question
                      ? questionOptionsInput.question
                      : ''
                  }
                  onChange={handleQuestionOptionChange}
                  name="question"
                />
              </Colxx>
            </Row>
            <Row className="mb-2">
              <Colxx xxs="3">
                <Label>Save to Slot</Label>
                <Input
                  type="text"
                  value={
                    questionOptionsInput.slot ? questionOptionsInput.slot : ''
                  }
                  onChange={handleQuestionOptionChange}
                  name="slot"
                />
              </Colxx>
              <Colxx xxs="3">
                <Label>Say After</Label>
                <Input
                  type="text"
                  value={
                    questionOptionsInput.after ? questionOptionsInput.after : ''
                  }
                  onChange={handleQuestionOptionChange}
                  name="after"
                />
              </Colxx>
              <Colxx xxs="3">
                <Label>Always Ask</Label>
                <CustomInput
                  type="checkbox"
                  checked={questionOptionsInput.alwaysask}
                  name="alwaysask"
                  disabled="disabled"
                  onChange={handleCheckChange}
                />
              </Colxx>
              <Colxx xxs="3">
                <Label>Show Buttons</Label>
                <CustomInput
                  type="checkbox"
                  checked={questionOptionsInput.showButtons}
                  name="showButtons"
                  disabled="disabled"
                  onChange={handleCheckChange}
                />
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12">
                <TagsInput
                  inputProps={{ placeholder: 'Add Suggested Response' }}
                  value={questionOptionsInput.options}
                  onChange={(event) => handleQuestionOptionsChange(event)}
                />
              </Colxx>
            </Row>{' '}
          </Fragment>
        )}{' '}
        {messageType === 'HeroCard' && (
          <Fragment>
            {' '}
            <Row>
              <Colxx xxs="12" className="mb-2">
                <Input
                  type="text"
                  defaultValue={heroCardInput.title}
                  onChange={handleHeroCardInputChange}
                  placeholder="title"
                  name="title"
                />
              </Colxx>
              <Colxx xxs="12" className="mb-2">
                <Input
                  type="text"
                  defaultValue={heroCardInput.subTitle}
                  onChange={handleHeroCardInputChange}
                  placeholder="subtitle"
                  name="subtitle"
                />
              </Colxx>
              <Colxx xxs="12" className="mb-2">
                <Input
                  type="text"
                  value={heroCardInput.imageURL}
                  onChange={handleHeroCardInputChange}
                  placeholder="Image Url"
                  name="imageURL"
                />
              </Colxx>
            </Row>
            <Row>
              <Colxx xxs="12">
                <div
                  className="float-left"
                  style={{ marginTop: ' 5px', marginBottom: '5px' }}
                >
                  <Button
                    color="primary"
                    className="add-button"
                    size="xs"
                    onClick={togglegallery}
                  >
                    <IntlMessages id='dashboards.browsegallery' />
                  </Button>
                </div>
              </Colxx>
            </Row>
            <Row>
              {inputFields.map((domain, index) => (
                <Fragment key={index}>
                  <Colxx sm={4} className="md-3">
                    <Label>Type</Label>
                    <Input
                      type="select"
                      value={domain.type}
                      name="type"
                      onChange={(event) => handleInputChange(index, event)}
                    >
                      <option value="">Please select</option>
                      <option value="imBack">Send to Bot</option>
                      <option value="openUrl">Open in Browser</option>
                    </Input>
                  </Colxx>
                  <Colxx sm={3}>
                    <FormGroup>
                      <Label for="title">Title</Label>
                      <Input
                        type="text"
                        key={`priority_${index}`}
                        name="title"
                        id="title"
                        defaultValue={domain.title}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={2} className="mb-3">
                    <Label>Remove</Label>
                    <div>
                      <Button
                        onClick={() => handleRemoveFields(index)}
                        color="secondary"
                        size="xs"
                        outline
                        style={{ margin: '6px' }}
                      >
                        -
                      </Button>
                    </div>
                  </Colxx>
                </Fragment>
              ))}
            </Row>
            <Button
              onClick={handleAddFields}
              color="primary"
              size="xs"
              outline
              style={{ margin: '6px' }}
            >
              + Add Action
            </Button>
            {ImageGalleryButton()}
          </Fragment>
        )}
        <Row></Row>
      </Fragment>
    );
  };

  return (
    <Card>
      <CardBody>{Editing()}</CardBody>
    </Card>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps)(Message));
